import React from 'react';
import classNames from 'classnames';

import css from './IconPlay.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconPlay = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="90"
      height="90"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" rx="60" fill="white" />
      <path
        d="M84 53.0718C89.3333 56.151 89.3333 63.849 84 66.9282L54 84.2487C48.6667 87.3279 42 83.4789 42 77.3205L42 42.6795C42 36.5211 48.6667 32.6721 54 35.7513L84 53.0718Z"
        fill="#A8CAF0"
      />
    </svg>
  );
};

export default IconPlay;
